import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import { AdminCompany, AdminCompanyUpdate } from './types';

export const ADMIN_COMPANY = {
  getAdminCompany: '/api/v1/Admin/Company',
  updateAdminCompany: '/api/v1/Admin/Company',
  deleteAdminCompanu: '/api/v1/Admin/Company',
};

export const getAdminCompany = (): ApiPromise<
  DataResponse<AdminCompany>,
  ErrorResponse
> =>
  API.get<DataResponse<AdminCompany>, ErrorResponse>(
    ADMIN_COMPANY.getAdminCompany,
  );

export const updateAdminCompany = (
  body: AdminCompanyUpdate,
): ApiPromise<DataResponse<AdminCompany>, ErrorResponse> =>
  API.put<DataResponse<AdminCompany>, ErrorResponse>(
    ADMIN_COMPANY.updateAdminCompany,
    body,
  );

export const deleteUpdateAdminCompany = (): ApiPromise<
  DataResponse<AdminCompany>,
  ErrorResponse
> =>
  API.delete<DataResponse<AdminCompany>, ErrorResponse>(
    ADMIN_COMPANY.deleteAdminCompanu,
  );
